import React from 'react';
import Display from './Display';
import ButtonPanel from './ButtonPanel';
import './Calculator.css';
import Calculate from './Calculate'

class Calculator extends React.Component {
    state = {
        total: '',
    }

    handleClick = buttonName => {
        this.setState((state)=>Calculate(state, buttonName))
    }

    render() {
        return (
            <React.Fragment>
            <div className="calc-container">
                  <Display value={ this.state.total} />
            <ButtonPanel clickHandler={this.handleClick} />
            </div>
           </React.Fragment> 

        )
    }
};

export default Calculator;